const features = [
  {
    icon: 'ri-flashlight-line',
    title: '极速播放',
    desc: '多线路智能切换，高清视频秒开不缓冲，畅快观影体验',
  },
  {
    icon: 'ri-shield-check-line',
    title: '安全稳定',
    desc: '春色影视最新网址入口持续更新，确保您随时稳定访问，安全无忧',
  },
  {
    icon: 'ri-smartphone-line',
    title: '全端适配',
    desc: '电脑、平板、手机完美适配，随时随地畅享高清影视',
  },
  {
    icon: 'ri-refresh-line',
    title: '每日更新',
    desc: '资源库每日更新，最新电影电视剧第一时间同步上线',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-5xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 text-center">
          平台特色
        </h2>
        <p className="mt-2 text-sm text-foreground-500 text-center">为什么选择色影视</p>

        <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {features.map((feat) => (
            <div key={feat.title} className="text-center p-6">
              <div className="w-14 h-14 mx-auto rounded-2xl bg-accent-100 flex items-center justify-center">
                <i className={`${feat.icon} text-2xl text-accent-600`}></i>
              </div>
              <h3 className="mt-4 text-base font-semibold text-foreground-900 font-heading">
                {feat.title}
              </h3>
              <p className="mt-2 text-sm text-foreground-600 leading-relaxed">{feat.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}